<template>
  <v-layout
      row
      align-center
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-row>
        <v-col cols="12" md="6">
          <v-card
              class="ml-3 mr-3"
              outlined
          >
            <v-card-title
            >
              Edit Outlet
            </v-card-title>
            <hr class="ma-1">
            <div class="col">
              <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
              >
                <v-select
                    :items="groups"
                    label="Group *"
                    :rules="groupRules"
                    item-text="name"
                    item-value="id"
                    v-model="outlet.group_id"
                ></v-select>
                <v-text-field
                    v-model="outlet.name"
                    :rules="nameRules"
                    label="Name *"
                    autocomplete="off"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="outlet.short_name"
                    label="Short Name"
                    autocomplete="off"
                    counter="10"
                    maxlength="10"
                    hint="will be used as sms sender."
                ></v-text-field>

                <v-text-field
                    v-model="outlet.description"
                    label="Description"
                    autocomplete="off"
                ></v-text-field>

                <v-text-field
                    v-model="outlet.restaurant_id"
                    :disabled="!(user === 'superadmin' || user === 'admin')"
                    label="Restaurant ID"
                    autocomplete="off"
                ></v-text-field>
                <v-text-field
                    v-model="outlet.gems_group_id"
                    :disabled="!(user === 'superadmin' || user === 'admin')"
                    label="Gems Group ID"
                    autocomplete="off"
                ></v-text-field>

                <div class="pt-3 pl-3 pb-1">
                  <v-row>
                    <v-label class="mt-5">Operation Times</v-label>
                    <v-btn
                        class="ml-2"
                        x-small
                        color="success"
                        @click="timesDialog = true"
                    >
                      +
                    </v-btn>
                  </v-row>
                  <div v-if="operationTimes.length > 0">
                    <v-label>Operation:</v-label>
                    <v-row class="pa-3">
                      <v-input
                          v-for="(ot) in operationTimes"
                          append-icon="close"
                          :key="ot.id"
                          background-color="#F5F5F5"
                          @click:append="removeOperationTime(ot)"
                      >
                        {{ convertDayName(ot.day) }} <br> {{ ot.time }}
                      </v-input>
                    </v-row>
                  </div>
                  <div v-if="breakTimes.length > 0">
                    <v-label>Break:</v-label>
                    <v-row class="pa-3">
                      <v-input
                          v-for="(bt) in breakTimes"
                          append-icon="close"
                          :key="bt.id"
                          background-color="#F5F5F5"
                          @click:append="removeOperationTime(bt)"
                      >
                        {{ convertDayName(bt.day) }} <br> {{ bt.time }}
                      </v-input>
                    </v-row>
                  </div>
                </div>

                <v-dialog
                    v-model="timesDialog"
                    width="400"
                >
                  <v-card>
                    <v-row>
                      <v-col>
                        <v-card-title>Operation Time</v-card-title>
                      </v-col>
                      <v-col>
                        <v-btn class="text-right float-right" text @click="timesDialog = !timesDialog">X</v-btn>
                      </v-col>
                    </v-row>
                    <v-radio-group class="mt-0 pa-4" v-model="type" :mandatory="false" row>
                      <v-radio label="Operation" value="operation"
                               @change="changeDay('all')"></v-radio>
                      <v-radio label="Break" value="break" @change="changeDay('break')"></v-radio>
                    </v-radio-group>
                    <v-select
                        :items="days"
                        :item-text="days.name"
                        label="Day"
                        v-model="day"
                        multiple
                        outlined
                        class="mr-0 pl-4 col-11"
                    ></v-select>

                    <v-text-field
                        v-model="time"
                        label="Time"
                        placeholder="e.g: 1300-1500"
                        autocomplete="off"
                        outlined
                        class="mr-0 pl-4 col-11"
                    ></v-text-field>
                    <v-btn @click="addTime" class="font-weight-bold ml-4 mb-4" color="success">Save</v-btn>
                  </v-card>
                </v-dialog>

                <template>
                  <v-file-input
                      accept="image/*"
                      :rules="bgRules"
                      label="Background"
                      id="bgimage"
                      name="background"
                      show-size
                      persistent-hint
                      hint="1200x400px, 2MB"
                  ></v-file-input>
                </template>
                <template>
                  <v-file-input
                      accept="image/png"
                      :rules="logoRules"
                      label="Logo"
                      id="logoimage"
                      name="logo"
                      show-size
                      persistent-hint
                      hint=".png, max. 540x540px, 300kB, * use image with same width and height to get the best effect."
                  ></v-file-input>
                </template>
              <template v-model="outlet.screen_saver">
                  <v-file-input
                      accept="image/png"
                      :rules="bgRules"
                      label="Screen Saver"
                      id="screensaverimage"
                      name="screensaver"
                      show-size
                      persistent-hint
                      hint="1200x400px, 2MB"
                  ></v-file-input>
                </template>

                <v-row class="pl-3 ml-2">
                  <div
                      class="pa-3 ma-2"
                      v-if="outlet.bg_image"
                  >
                      <v-card-subtitle>Background Image</v-card-subtitle>
                    <v-row>
                      <v-img
                          :src="myBg"
                          height="100"
                          width="100"
                          class="my-logo"
                          alt="logo"
                          contain
                      />
                      <v-icon small @click="remove('bg_image')">close</v-icon>
                    </v-row>
                  </div>

                  <div
                      class="pa-3 ma-2"
                      v-if="outlet.logo"
                  >
                      <v-card-subtitle>Background Image</v-card-subtitle>
                    <v-row>
                      <v-img
                          :src="myLogo"
                          height="100"
                          width="100"
                          class="my-logo"
                          alt="logo"
                          contain
                      />
                      <v-icon small @click="remove('logo')">close</v-icon>
                    </v-row>
                  </div>

                <div
                      class="pa-3 ma-2"
                      v-if="outlet.screen_saver_img"
                  >
                      <v-card-subtitle>Screen Saver Image</v-card-subtitle>
                    <v-row>
                      <v-img
                          :src="myScreenSaver"
                          height="100"
                          width="100"
                          class="my-logo"
                          alt="logo"
                          contain
                      />
                      <v-icon small @click="remove('screen_saver')">close</v-icon>
                    </v-row>
                  </div>
                </v-row>

                <v-text-field
                    v-model="outlet.main_color"
                    label="Main Color"
                    autocomplete="off"
                    placeholder="#000000"
                    persistent-hint
                    hint="leave blank to use default color"
                ></v-text-field>
                <v-col cols="12">
                  <header>Layout Font Color</header>

                  <v-radio-group class="mt-0" v-model="outlet.main_font_color" row>
                    <v-radio
                        label="white"
                        value="white"
                    ></v-radio>
                    <v-radio
                        label="black"
                        value="black"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12">
                  <header>Page Rotation</header>

                  <v-radio-group class="mt-0" v-model="outlet.page_rotation" row>
                    <v-radio
                        label="Normal"
                        :value="0"
                    ></v-radio>
                    <v-radio
                        label="90 Degrees Counterclockwise"
                        :value="1"
                    ></v-radio>
                    <v-radio
                        label="90 Degrees Clockwise"
                        :value="2"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-switch
                    v-model="outlet.onsite_email"
                    label="Onsite Email"
                ></v-switch>
                <v-switch
                    v-model="outlet.onsite_name"
                    label="Onsite Name"
                ></v-switch>
                <v-switch
                    v-model="outlet.onsite_phone"
                    label="Onsite Phone Number"
                ></v-switch>

                <v-switch
                    v-model="outlet.onsite_remarks"
                    label="Onsite Remarks"
                ></v-switch>

                <v-text-field
                    v-model="outlet.onsite_remarks_label"
                    label="Onsite Remarks Label"
                    autocomplete="off"
                ></v-text-field>

                <v-switch
                    v-model="outlet.onsite_send_sms"
                    label="Onsite Send SMS"
                ></v-switch>

                <v-switch
                    v-model="outlet.walkin_as_arrived"
                    label="Walk-in Mark As Arrived"
                ></v-switch>

                <v-switch
                    v-model="outlet.health_declaration"
                    label="Onsite Health Declaration Form"
                ></v-switch>

                <v-switch
                    v-model="outlet.screen_saver"
                    label="Onsite Screen Saver"
                ></v-switch>

                  <div class="mt-4 mb-4 pt-2">
              <label for="editor2">Onsite Information Text</label>
              <textarea class="form-control" id="editor2" name="onsite_information_content"
                        v-model="outlet.onsite_information_content">
                            {{ outlet.onsite_information_text }}
                        </textarea>
              <span style="font-size: smaller">*Keyword:
                    <span v-for="(keyword, index) in keywords" class="p-0">
                        <v-btn color="blue" text x-small class="no-uppercase pl-0 pr-0" @click="copyTestingCode(keyword)">{{ keyword }}</v-btn>
                        <span v-if="index !== keywords.length - 1"> , </span>
                    </span>
                    <input type="hidden" id="testing-code">
              </span><br>
              <span style="color:grey; font-size: smaller">*Leave this field blank to use default content</span>
                  </div>
                  <div class="mt-4 mb-4 pt-2">
                <label for="editor">Onsite Confirm Page Content</label>
                <textarea class="form-control" id="editor" name="onsite_details_content"
                          v-model="outlet.onsite_details_content">
                                {{ outlet.onsite_details_content }}
                </textarea>
                <span style="font-size: smaller">*Keyword:
                    <span v-for="(keyword, index) in keywords" class="p-0">
                        <v-btn color="blue" text x-small class="no-uppercase pl-0 pr-0" @click="copyTestingCode(keyword)">{{ keyword }}</v-btn>
                        <span v-if="index !== keywords.length - 1"> , </span>
                    </span>
                </span><br>
                <span style="color:grey; font-size: smaller">*this content will only show for queue with 'onsite print' on</span>
                <span style="color:grey; font-size: smaller">*Leave this field blank to use default content</span>
                  </div>

                  <v-text-field
                      v-model="outlet.onsite_unavailable_message"
                      label="Onsite Unavailable Message"
                      autocomplete="off"
                  ></v-text-field>
                  <span style="font-size: smaller">*Keyword:
                      <v-btn color="blue" text x-small class="no-uppercase pl-0 pr-0" @click="copyTestingCode('{qName}')">{qName}</v-btn>
                  </span><br>

                <v-dialog v-model="editTicket">
                  <v-card class="pa-2">
                    <v-row>
                      <v-col>
                        <v-card-title>Ticket Content</v-card-title>
                      </v-col>
                      <v-col>
                        <v-btn class="text-right float-right" text @click="editTicket = !editTicket">X</v-btn>
                      </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    <v-row v-for="(input, index) in ticketContent" :key="index" class="pa-5">
                      <v-col cols="3" class="pa-1">
                        <v-select v-model="input.type"
                                  :items="ticketContentTypes"
                                  label="Type"></v-select>
                      </v-col>
                      <v-col cols="7" class="pa-1">
                        <v-text-field v-model="input.content"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="pa-1">
                        <v-btn
                            text
                            color="error"
                            class="font-weight-bold"
                            @click="deleteRow(index)">Delete
                        </v-btn>
                      </v-col>
                    </v-row>
                    <div class="ma-3">
                        <span style="font-size: smaller">*Keyword:
                            <input type="hidden" id="testing-code2">
                            <span v-for="(keyword, index) in keywords" class="p-0">
                                <v-btn color="blue" text small class="no-uppercase pl-0 pr-0" @click="copyTestingCode(keyword,'ticket')">{{ keyword }}</v-btn>
                                <span v-if="index !== keywords.length - 1"> , </span>
                            </span>
                        </span>
                    </div>
                    <div class="ma-3">
                      <v-btn
                          color="primary"
                          class="font-weight-bold"
                          @click="addRow">Add row
                      </v-btn>
                      <v-btn
                          color="info"
                          class="font-weight-bold"
                          @click="preview = true">Preview
                      </v-btn>
                      <v-btn
                          color="success"
                          class="font-weight-bold"
                          @click="submitTicket">Save
                      </v-btn>
                    </div>
                  </v-card>
                </v-dialog>
                <v-dialog
                    v-model="preview"
                    max-width="450"
                    width="450"
                >
                  <v-card>
                    <v-row v-for="(input, index) in ticketContent" :key="index">
                      <v-card-text v-if="input.type === 'Text-Big'" class="text-center"
                                   style="font-size: large;font-weight: bold" v-html="replaceVariable(input.content)">
                      </v-card-text>
                      <v-card-text v-if="input.type === 'Text-Small'" class="text-center" v-html="replaceVariable(input.content)">
                      </v-card-text>
                      <v-card-text v-if="input.type === 'Empty-Lin'" class="text-center">
                        {{ replaceVariable(input.content) }}
                      </v-card-text>
                    </v-row>
                  </v-card>

                </v-dialog>
                <br>
                <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4 mr-4 mt-4 font-weight-bold"
                    @click="submit"
                >
                  Save
                </v-btn>
              </v-form>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="ml-3 mr-3" outlined>
            <v-card-title class="pl-5 pb-0">Link</v-card-title>
            <hr class="ma-0 pa-0">
            <v-list>
              <v-list-item @click="onsiteLink()">
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Onsite:</v-list-item-title>
                  <v-list-item-subtitle>https://qms.aptsys.com.sg/outlet/{{ outlet.id }}/onsite
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="onlineLink()">
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Online:</v-list-item-title>
                  <v-list-item-subtitle>https://qms.aptsys.com.sg/outlet/{{ outlet.id }}/online
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="displayLink()">
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Queue Number Display:</v-list-item-title>
                  <v-list-item-subtitle>https://qms.aptsys.com.sg/display_number/{{ outlet.slug }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="monitorLink()">
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Monitor All Queues:</v-list-item-title>
                  <v-list-item-subtitle>https://qms.aptsys.com.sg/outlet/{{ outlet.id }}/monitor_queues
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>

          <v-card class="mt-3 ml-3 mr-3" outlined>
            <v-row>
              <v-col>
                <v-card-title class="pl-5 pb-0">Printer IP</v-card-title>
              </v-col>
              <v-col
                  class="text-right"
                  v-if="!outlet_ip"
              >
                <v-btn
                    small
                    :class="addBtnStyle"
                    @click="createIP"
                >
                  +
                </v-btn>
              </v-col>
            </v-row>
            <hr class="ma-0 pa-0">
            <v-list v-if="outlet_ip">
              <v-list-item
                  @click="manageIP(outlet_ip.id)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-html="outlet_ip.name"></v-list-item-title>
                  <v-list-item-title v-html="outlet_ip.ip"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>

          <v-card class="mt-3 ml-3 mr-3" outlined>
            <v-row>
              <v-col>
                <v-card-title class="pl-5 pb-0">Queues</v-card-title>
              </v-col>
              <v-col
                  class="text-right"
              >
                <v-btn
                    small
                    :class="addBtnStyle"
                    @click="createQ"
                >
                  +
                </v-btn>
              </v-col>
            </v-row>
            <hr class="ma-0 pa-0">
            <v-list>
              <v-list-item
                  v-for="q in queues"
                  :key="q.id"
                  @click="manageQueue(q.id)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-html="q.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="q.description"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
          <v-card class="mt-3 ml-3 mr-3" outlined>
            <v-row>
              <v-col>
                <v-card-title class="pl-5 pb-0">Services</v-card-title>
              </v-col>
              <v-col
                  class="text-right"
              >
                <v-btn
                    small
                    :class="addBtnStyle"
                    @click="createService"
                >
                  +
                </v-btn>
              </v-col>
            </v-row>
            <hr class="ma-0 pa-0">
            <v-list>
              <v-list-item
                  v-for="service in services"
                  :key="service.id"
                  @click="manageService(service.id)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-html="service.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="service.description"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
          <v-card class="mt-3 ml-3 mr-3" outlined>
            <v-row>
              <v-col>
                <v-card-title class="pl-5 pb-0">Blacklist</v-card-title>
              </v-col>
              <v-col
                  class="text-right"
              >
                <v-btn
                    small
                    :class="addBtnStyle"
                    @click="createBlacklist"
                >
                  +
                </v-btn>
              </v-col>
            </v-row>
            <hr class="ma-0 pa-0">
            <v-list>
              <v-list-item
                  v-for="blacklist in blacklists"
                  :key="blacklist.id"
              >
                <v-list-item-icon ma-1>
                  <v-icon small>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-html="blacklist.phone_no"></v-list-item-title>
                  <v-list-item-subtitle v-html="blacklist.remarks"></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                      icon
                      @click="removeBlacklist(blacklist)"
                  >
                    <v-icon color="grey lighten-1">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
          <v-card class="mt-3 ml-3 mr-3" outlined>
            <v-row>
              <v-col>
                <v-card-title class="pl-5 pb-0">Others</v-card-title>
              </v-col>
            </v-row>
            <hr class="ma-0 pa-0">
            <v-btn
                class="ma-2 font-weight-bold"
                @click="setDisplay"
                color="primary"
            >Queue Number Display Setting
            </v-btn>
            <v-btn
                class="ma-2 font-weight-bold"
                color="primary"
                @click="reports"
            >Reports
            </v-btn>
            <v-btn
                class="ma-2 font-weight-bold"
                color="primary"
                @click="editTicket = !editTicket"
            >Ticket Content
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  data: () => ({
    preview: false,
    editTicket: false,
    ticketContentTypes: ['Text-Big', 'Text-Small', 'Empty-Line'],
    editor: ClassicEditor,
    editor2: ClassicEditor,
    valid: true,
    nameRules: [
      v => !!v || 'Name is required',
    ],
    groupRules: [
      v => !!v || 'Group is required',
    ],
    bgRules: [
      value => !value || value.size < 2000000 || 'Image size should be less than 2 MB!',
    ],
    logoRules: [
      value => !value || value.size < 300000 || 'Image size should be less than 300 kB!',
    ],
    timesDialog: false,
    type: 'operation',
    day: null,
    time: null,
    days: [],
    breakDays: '',
    daySelection: [
      {text: 'Sunday', value: 0},
      {text: 'Monday', value: 1},
      {text: 'Tuesday', value: 2},
      {text: 'Wednesday', value: 3},
      {text: 'Thursday', value: 4},
      {text: 'Friday', value: 5},
      {text: 'Saturday', value: 6}
    ],
    breakTimes: [],
    operationTimes: [],
    outlet_ip: null,
    blacklists: [],
    breadcrumbsItems: '',
    showCK: false,
    ticketContent: [],
    keywords: ['{qName}','{qNo}','{qLength}','{estimatedTime}', '{outletName}', '{currentDate}', '{currentDateTime}']
  }),
  props: ['groups', 'outlet', 'queues', 'services', 'user'],
  computed: {
    myLogo() {
      return '/storage' + this.outlet.logo;
    },
    myBg() {
      return '/storage' + this.outlet.bg_image;
    },
    myScreenSaver() {
      return '/storage' + this.outlet.screen_saver_img;
    },
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    },
    addBtnStyle() {
      return 'success ma-3 font-weight-bold'
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        let bgimage = document.querySelector('#bgimage');
        let logoimage = document.querySelector('#logoimage');
        let screensaverimage = document.querySelector('#screensaverimage');
        let formData = new FormData();

        formData.append('name', this.outlet.name);
        formData.append('group_id', this.outlet.group_id);
        //nullable
        if (this.outlet.short_name) formData.append('short_name', this.outlet.short_name);
        if (this.outlet.description) formData.append('description', this.outlet.description);
        if (this.outlet.gems_group_id) formData.append('gems_group_id', this.outlet.gems_group_id);
        if (this.outlet.restaurant_id) formData.append('restaurant_id', this.outlet.restaurant_id);
        if (this.outlet.slogan) formData.append('slogan', this.outlet.slogan);
        if (this.outlet.main_color) formData.append('main_color', this.outlet.main_color);
        if (this.outlet.main_font_color) formData.append('main_font_color', this.outlet.main_font_color);
        formData.append('page_rotation', this.outlet.page_rotation);
        if (this.outlet.slogan_color) formData.append('slogan_color', this.outlet.slogan_color);
        // if (this.outlet.onsite_print) formData.append('onsite_print', this.outlet.onsite_print);
        if (this.outlet.onsite_email) formData.append('onsite_email', this.outlet.onsite_email);
        if (this.outlet.onsite_name) formData.append('onsite_name', this.outlet.onsite_name);
        if (this.outlet.onsite_phone) formData.append('onsite_phone', this.outlet.onsite_phone);
        if (this.outlet.onsite_remarks) formData.append('onsite_remarks', this.outlet.onsite_remarks);
        if (this.outlet.onsite_remarks_label) formData.append('onsite_remarks_label', this.outlet.onsite_remarks_label);
        if (this.outlet.onsite_send_sms) formData.append('onsite_send_sms', this.outlet.onsite_send_sms);
        if (this.outlet.walkin_as_arrived) formData.append('walkin_as_arrived', this.outlet.walkin_as_arrived);
        if (this.outlet.health_declaration) formData.append('health_declaration', this.outlet.health_declaration);
        if (this.outlet.screen_saver) formData.append('screen_saver', this.outlet.screen_saver);
        if (this.outlet.onsite_unavailable_message) formData.append('onsite_unavailable_message', this.outlet.onsite_unavailable_message);
        formData.append('onsite_details_content', CKEDITOR.instances.editor.getData());
        formData.append('onsite_information_content', CKEDITOR.instances.editor2.getData());
        // image file
        formData.append('background', bgimage.files[0]);
        formData.append('logo', logoimage.files[0]);
        formData.append('screensaver', screensaverimage.files[0]);
        axios.post('/outlet/' + this.outlet.id, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
            swal({
                title: 'Outlet updated!',
                timer: 3000,
                icon: "success",
                buttons: false
            }).then(function () {
                window.location.reload()
                window.scrollTo(0, 0)
            })
        });
      }
    },
    manageQueue(qid) {
      window.location.href = '/outlet/' + this.outlet.id + '/queue/' + qid
    },
    manageService(sid) {
      window.location.href = '/outlet/' + this.outlet.id + '/service/' + sid + '/edit'
    },
    manageIP(ipid) {
      window.location.href = '/outlet/' + this.outlet.id + '/ip/' + ipid + '/edit'
    },
    addTime() {
      axios.post('/operation_times', {
        days: this.day,
        time: this.time,
        type: this.type,
        model_id: this.outlet.id,
        model_type: 'App\\Outlet'
      }).then(response => {
        response.data.type === 'operation' ? this.operationTimes.push(response.data) : this.breakTimes.push(response.data);
        if (response.data.type === 'operation') this.breakDays += response.data.day;
        let bd = '';
        this.operationTimes.forEach(function (t, idx, array) {
          if (idx !== array.length - 1) {
            bd += t.day + ','
          } else {
            bd += t.day
          }
        });
        this.breakDays = bd;
        // reset value
        this.type = 'operation';
        this.day = null;
        this.time = null;
        this.timesDialog = false;
      })
    },
    convertDayName(day) {
      let dayName = '';
      if (typeof day !== 'undefined') {
        let d2 = day.split(",");
        this.daySelection.forEach(function (d) {
          d2.forEach(function (x) {
            if (d.value === parseInt(x)) dayName += d.text + ','
          })
        });
      }
      return dayName;
    },
    removeOperationTime(t) {
      // axios to remove operation time
      let type = t.type;
      const i = type === 'operation' ? this.operationTimes.indexOf(t) : this.breakTimes.indexOf(t);
      axios.delete('/operation_times/' + t.id).then(response => {
        type === 'operation' ? this.operationTimes.splice(i, 1) : this.breakTimes.splice(i, 1);
      });
    },
    createQ() {
      window.location.href = '/outlet/' + this.outlet.id + '/queue/create'
    },
    createService() {
      window.location.href = '/outlet/' + this.outlet.id + '/service/create'
    },
    createIP() {
      window.location.href = '/outlet/' + this.outlet.id + '/ip/create'
    },
    changeDay(type) {
      if (type === 'all') this.days = this.daySelection;
      if (type === 'break') {
        let b = this.breakDays;
        let result = [];
        this.daySelection.forEach(function (d) {
          if (b.includes(d.value)) result.push(d);
        });
        this.days = result;
      }
    },
    remove(img) {
      axios.get('/outlet/' + this.outlet.id + '/removePath?type=' + img).then(response => {
        window.location.reload();
      });
    },
    onsiteLink() {
      window.open('/outlet/' + this.outlet.id + '/onsite')
    },
    onlineLink() {
      window.open('/outlet/' + this.outlet.id + '/online')
    },
    displayLink() {
      window.open('/display_number/' + this.outlet.slug)
    },
    monitorLink() {
      window.open('/outlet/' + this.outlet.id + '/monitor_queues')
    },
    createBlacklist() {
      window.location.href = '/outlet/' + this.outlet.id + '/blacklist/create'
    },
    removeBlacklist(blacklist) {
      axios.delete('/outlet/' + this.outlet.id + '/blacklist/' + blacklist.id).then(response => {
        this.blacklists.splice(this.blacklists.indexOf(blacklist), 1);
      });
    },
    setDisplay() {
      window.location.href = '/outlet/' + this.outlet.id + '/display_number_setting'
    },
    reports() {
      window.location.href = '/outlet/' + this.outlet.id + '/reports'
    },
    addRow() {
      this.ticketContent.push({
        type: '',
        content: ''
      })
    },
    deleteRow(index) {
      this.ticketContent.splice(index, 1)
    },
    submitTicket() {
      console.log(this.ticketContent)
      axios.post('/api/outlet/ticket_content', {
        ticketContent: this.ticketContent,
        oid: this.outlet.id
      }).then(response => {
          swal({
              title: 'Outlet updated!',
              buttons: false,
              timer: 3000,
              icon: "success"
          }).then( function () {
              window.location.reload()
              window.scrollTo(0, 0)
          })
      })
    },
    replaceVariable(content) {
      //{qName},{qNo},{qLength},{estimatedTime}, {outletName}
      content = content.replace('{qName}', '"Queue Name"')
      content = content.replace('{qNo}', '1')
      content = content.replace('{qLength}', '"1"')
      content = content.replace('{estimatedTime}', '10:00 PM')
      content = content.replace('{outletName}', this.outlet.name)
      content = content.replace('{currentDate}', '31-12-2020')
      content = content.replace('{currentDateTime}', '31-12-2020 10:00:00')
      return content.replace(/(.{45})/g, "$1<br>")
    },
    copyTestingCode (keyword, type = null) {
      let testingCodeToCopy = type ? document.querySelector('#testing-code2') : document.querySelector('#testing-code')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.setAttribute('value', keyword)
      testingCodeToCopy.select()

      try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'successful' : 'unsuccessful';
          swal({
              title: 'Keyword ' + keyword + ' was copied ' + msg,
              timer: 1250,
              icon: "success",
              buttons: false
          })
      } catch (err) {
          swal({
              title: 'Oops, unable to copy',
              timer: 1250,
              icon: "error",
              buttons: false
          })
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  },
  beforeMount() {
    axios.get('/api/operation_times/model?type=operation&oid=' + this.outlet.id).then(response => {
      this.operationTimes = response.data;
      let bd = '';
      response.data.forEach(function (t, idx, array) {
        if (idx !== array.length - 1) {
          bd += t.day + ','
        } else {
          bd += t.day
        }
      });
      this.breakDays = bd;
    });
    axios.get('/api/operation_times/model?type=break&oid=' + this.outlet.id).then(response => {
      this.breakTimes = response.data
    });
    axios.get('/api/getOutletIP?oid=' + this.outlet.id).then(response => {
      this.outlet_ip = response.data;
    });
    axios.get('/api/getBlackList?gid=' + this.outlet.group_id).then(response => {
      this.blacklists = response.data;
    });
    this.days = this.daySelection;
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: this.outlet.name,
      },
    ];
    if (this.outlet.onsite_ticket_content) {
      this.ticketContent = JSON.parse(this.outlet.onsite_ticket_content)
    }
  }
}
</script>
<style>
.no-uppercase {
    text-transform: none;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Outlets/OutletEdit.vue